import { render, staticRenderFns } from "./AWSAccountsInput.vue?vue&type=template&id=0d85c2ae&scoped=true&"
import script from "./AWSAccountsInput.vue?vue&type=script&lang=ts&"
export * from "./AWSAccountsInput.vue?vue&type=script&lang=ts&"
import style0 from "./AWSAccountsInput.vue?vue&type=style&index=0&id=0d85c2ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d85c2ae",
  null
  
)

export default component.exports